import { Grid, Paper, Table, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import MigaPan from "../../../app/orussystem/component/MigaPan";
import { findQuestionByIdPoll, createNewOpenQuestionPoll, editQuestionPolls } from "../../domain/EncuestasApi";
import { PollPanelStyle } from "../../infrastructure/PollPanelStyle";
import ListQuestion from "./listQuestion";
import ModalQuestion from "./modalFormQuestion";
import { useParams } from "react-router-dom";
import { Store } from "react-notifications-component";
import 'react-notifications-component/dist/theme.css'
import { panelUsersAuthStyle } from "../../../centraldevida/users_auth/panelUsersAuthStyle";
import theme from "../../../app/config/themaConfig";


export const PanelQuestion = () => {
  const clases = panelUsersAuthStyle()

  const classes = PollPanelStyle();
  const [list, setList] = useState([])
  const [isLoanding, setIsLoanding] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [dataEdit, setdataEdit] = useState({})
  const [isReload, setIsReload] = useState()


  const [isEdit, setisEdit] = useState(false)
  let { id } = useParams()
  let idPoll = id === ":id" || id === "" ? 0 : id;

  const setAsyncData = (data) => {
    return new Promise((resolve, reject) => {
      resolve(setdataEdit(data));
    })
  }

  const handledEditQuestion = async (data) => {
    setisEdit(true)
    setAsyncData(data).then((data) => setOpenModal(true))
  }

  const createQuestion = (request) => {
    if (request.type === "C") {
      const data = {
        description: request.question,
        type: request.type,
        poll: idPoll,
        answers: request.answers,
        type_wsp: "string",
        uuid_template: "string",
        status: true
      }

      createNewOpenQuestionPoll(data)
        .then((response) => {

          if (response.codigo === "0000") {

            Store.addNotification({
              title: "Creando Exitosamente!",
              message: `la pregunta ${request.question} fue creada con exito!`,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true
              }
            });
            setIsReload(true)
            setOpenModal(false)
          } else {
            Store.addNotification({
              title: "Algo salio mal",
              message: response.mensaje,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true
              }
            });
            setIsReload(true)
            setOpenModal(false);
          }

        }).catch((err) => {

        })
    } else {

      const data = {
        description: request.question,
        type: request.type,
        poll: idPoll,
        type_wsp: "string",
        uuid_template: "string",
        status: true
      }

      createNewOpenQuestionPoll(data)
        .then((response) => {

          if (response.codigo === "0000") {

            Store.addNotification({
              title: "Creando Exitosamente!",
              message: `la pregunta ${request.question} fue creada con exito!`,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true
              }
            });
            setIsReload(!isReload)
            setOpenModal(false);

          } else {
            Store.addNotification({
              title: "Algo salio mal",
              message: response.mensaje,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true
              }
            });
            setIsReload(!isReload)
            setOpenModal(false);

          }


        }).catch((err) => {

        })

    }
  }

  const editQuestion = (request) => {

    editQuestionPolls(request)
      .then((response) => {

        if (response.codigo === "0000") {

          Store.addNotification({
            title: "Editado Exitosamente!",
            message: `la pregunta ${request.description} fue Editada con exito!`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });
          setIsReload(!isReload)
          setOpenModal(false);

        } else {
          Store.addNotification({
            title: "Algo salio mal",
            message: response.mensaje,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });
          setIsReload(!isReload)
          setOpenModal(false);

        }


      }).catch((err) => {

      })


  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoanding(true)
      const listQuestion = await findQuestionByIdPoll(idPoll);
      setList(listQuestion.respuesta);
      setIsLoanding(false);
    }
    fetchData();
  }, [isReload, idPoll]);
  const primaryColor = theme.palette.primary.main;


  return (
    <>
      {openModal && <ModalQuestion
        setopenMondal={setOpenModal}
        isOpen={openModal}
        dataEdit={dataEdit}
        setdataEdit={setdataEdit}
        isEdit={isEdit}
        createQuestion={createQuestion}
        editQuestion={editQuestion}
        ID={idPoll}
      />}
      <Grid item xs={12} >
        <br></br>
        <br></br>
        <MigaPan namePage="Preguntas" to="/" namePage2="Encuestas" to2="/Pollpanel" >
          Home
        </MigaPan>
      </Grid>
      <Paper className={classes.paper} style={{ width: '100%' }} >
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} size={12} className={classes.searchContainer} >
              <Typography
                style={{
                  width: '100%',
                  fontSize: '25px',
                  fontWeight: 'bold',
                  marginTop: '1%',
                  marginBottom: '2%',
                  textAlign:'left'
                }}
                color='primary'>
                Preguntas
              </Typography>
            </Grid>
            <Grid item xs={12} size={12}>
              {/* Encabezados de la tabla */}


              <Table>
                <TableHead color='primary'>
                  <TableRow color='primary'>
                    <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}>Fecha creación</TableCell>
                    <TableCell className={clases.TableCell} style={{ paddingLeft: '10%', width: '30%', color: primaryColor }}>Pregunta</TableCell>
                    <TableCell className={clases.TableCell} style={{ width: '27.5%', paddingLeft: '10%', color: primaryColor }}>Tipo </TableCell>
                    <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '30%', color: primaryColor }}>Acciones</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Grid>
            <Grid item xs={12} size={12}>
              <ListQuestion
                rows={list}
                isLoadUser={isLoanding}
                handledEditQuestion={handledEditQuestion}
                idPoll={idPoll}
                primaryColor={primaryColor}
              />
            </Grid>
          </Grid>

        </Grid>
      </Paper>
    </>
  )
}